import { StateInterface } from 'client/Interfaces/StateInterface'
import { ThunkAction, ThunkDispatch } from 'redux-thunk'
import actionCreatorFactory, { Action, ActionCreator, AnyAction } from 'typescript-fsa'

export type AsyncActionCreator<T> = ActionCreator<() => Promise<T>>

export type AsyncAction<T> = Action<() => Promise<T>>

export const actionCreator = actionCreatorFactory()

export type ErrorActionCreator<ErrorType> = (error: ErrorType) => Action<ErrorType>

export function actionCreatorAsync<T, E = {}>(
  type: string,
  handler: () => Promise<T>,
  errorActionCreator?: ErrorActionCreator<E>,
): AsyncAction<T> {
  const asyncCreator: AsyncActionCreator<T> = Object.assign(
    (payload: () => Promise<T>) => ({ type, payload, meta: { async: true, errorActionCreator } }),
    { type, match: (action: AnyAction): action is Action<() => Promise<T>> => true },
  )
  return asyncCreator(handler)
}

export type IThunkDispatch = ThunkDispatch<StateInterface, any, AnyAction>
export type IThunkAction<E = unknown, A = string, R = void> = ThunkAction<R, StateInterface, E, Action<A>>
